(() => {
  const angular = window.angular;

  angular.module('app').config(Rounter);

  Rounter.$inject = ['$stateProvider'];

  function Rounter($stateProvider) {
    console.log('edgeAgentEditor router');
    $stateProvider.state('member.customer.show.edgeAgentEditor', {
      url: '/edge-agent-editor/:deviceId/:edgeAgentId',
      params: {
        deviceId: {
          type: 'string',
          dynamic: true,
          squash: true,
        },
        edgeAgentId: {
          type: 'string',
          dynamic: true,
          squash: true,
        },
      },
      component: 'edgeAgentEditor',
      authenticated: true,
      resolve: {
        module: [
          '$ocLazyLoad',
          function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              window.assetsPath + '/js/app/edge-agent-editor.module.min.js',
            ]);
          },
        ],
        device: [
          '$rootScope',
          'Customer',
          '$stateParams',
          function ($root, Customer, $stateParams) {
            const deviceId = $stateParams.deviceId;
            return Customer.devices({
              id: $root.customerId,
              filter: {
                where: {
                  id: deviceId,
                },
              },
            }).$promise.then(function (result) {
              if (result.length > 0) {
                return result[0];
              }
              throw new Error('Device not found');
            });
          },
        ],
        edgeAgent: [
          '$rootScope',
          'Customer',
          '$stateParams',
          function ($root, Customer, $stateParams) {
            const deviceId = $stateParams.deviceId;
            const edgeAgentId = $stateParams.edgeAgentId;
            return Customer.prototype$__get__devices__edgeAgents({
              id: $root.customerId,
              nk: deviceId,
              filter: {
                where: {
                  id: edgeAgentId,
                },
              },
            }).$promise.then(function (result) {
              if (result.length > 0) {
                return result[0];
              }
              throw new Error('Edge agent not found');
            });
          },
        ],
      },
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.EdgeAgentEditor" | translate}}',
      },
    });
  }
})();
